import 'carbon-components/scss/globals/scss/styles.scss';

import React, { useEffect, useState } from 'react';
import { loadUserGroup, loadOrg, loadLoginUserId, loadUserEmail } from '../../reducers/UserReducer';

import { Loading } from 'carbon-components-react';
import PageHeader from '../App/PageHeader';
import PageFooter from '../App/PageFooter';
import { connect } from 'react-redux';

import Dashboard from '../Dashboard/Dashboard';

import { useParams } from "react-router-dom";

import { SUBMISSION_STATUS_INITIAL_STATUS, SUBMISSION_STATUS_SUBMITTED } from '../../reducers/BaseReducer';

import instanaFavicon from '../../assets/icons/instana_60x60.png';
import { DEFAULT_BACKGROUND_COLOR, isInstana } from '../Helper/ComponentHelper';

const InitialPage = (props) => {
  const [backgroundColor, setBackgroundColor] = useState(DEFAULT_BACKGROUND_COLOR);
  let { customerId } = useParams();

  useEffect(() => {
    props.loadUserGroup();
    props.loadOrg();
    props.loadLoginUserId();
    props.loadUserEmail();
  }, []);

  useEffect(() => {
    if (props.currentAccess.headerMessage) {
      document.title = props.currentAccess.headerMessage;
    }

    if (props.currentAccess.backgroundColor) {
      setBackgroundColor(props.currentAccess.backgroundColor);
    } else {
      setBackgroundColor(DEFAULT_BACKGROUND_COLOR);
    }

    if (isInstana(props.currentAccess.solution)) {
      const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link');
      favicon.rel = 'icon';
      favicon.type = 'image/png';

      favicon.href = instanaFavicon;
      if (!document.querySelector("link[rel*='icon']")) {
        document.head.appendChild(favicon);
      }
    }
  }, [props.currentAccess]);

  if (props.user.authorizationSubmissionStatus === SUBMISSION_STATUS_INITIAL_STATUS
    || props.user.authorizationSubmissionStatus === SUBMISSION_STATUS_SUBMITTED) {
    return <Loading id="loadingAfterAuthenticationAndAuthorization" active={true} withOverlay={true} />
  }

  return (
    <div className="app" style={{ backgroundColor: backgroundColor }}>
      <PageHeader />
      <main id="content" className="app-main-content">
        <Dashboard customerId={customerId} />
      </main>
      <PageFooter />
    </div>
  );
}

export default connect(
  (state) => ({
    user: state.user,
    currentAccess: state.user.environmentSchema
  }),
  {
    loadUserGroup,
    loadOrg,
    loadLoginUserId,
    loadUserEmail
  }
)(InitialPage);